import Vue from 'vue'
import App from './App.vue'
require('./assets/css/main.css')
require('./assets/css/font.css')
import vueSmoothScroll from 'vue2-smooth-scroll';

Vue.use(vueSmoothScroll, {
  scrollTo: document.getElementById("base-editor-tables"),
  hash: "#base-editor-tables",
  duration: 1000,
  offset: -80
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
